import {
    ADMIN_GET_ACCOUNT_TYPE_SUCCESS,
    ADMIN_GET_ACCOUNT_TYPE_FAILED,
    LOADING_ADMIN_GET_ACCOUNT_TYPE,
    NETWORK_ERROR_ADMIN_GET_ACCOUNT_TYPE
} from "../types/index";
import { adminServices } from "../../config/axios";


const adminGetAccountTypeList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMIN_GET_ACCOUNT_TYPE });
    await adminServices
        .post("getAccounttypeList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: ADMIN_GET_ACCOUNT_TYPE_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: ADMIN_GET_ACCOUNT_TYPE_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMIN_GET_ACCOUNT_TYPE,
                payload: err
            });
        });
};

export { adminGetAccountTypeList }